// extracted by mini-css-extract-plugin
export var closeButton = "_hu-2";
export var closeButtonIcon = "_hu-3";
export var lightboxContent = "_hu-1";
export var lightboxOverlay = "_hu-0";